import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CurruncyFormat from '../../../CurruncyFormat';
import { useSelector } from 'react-redux';
import { getUnderlyingLiveFeed } from '../../../../stores/underlying-live-feed/getters';

const useStyles = makeStyles((theme) => ({
  root: {
    fontSize: 12,
    fontWeight: 500,
    paddingLeft: 0,
    lineEight: '18.2px',
    color: 'var(--color-pnl-card-font-5)',

    [theme.breakpoints.up('md')]: {
      paddingLeft: 0,
      fontSize: 14,
    },
  },
}));

const Price = ({ symbol }) => {
  const classes = useStyles();
  const ltp = useSelector((state) => {
    const value = getUnderlyingLiveFeed(state);

    const { ltp } = value[symbol] ? value[symbol] : {};

    return ltp;
  });

  return (
    <CurruncyFormat
      value={ltp ? ltp.toFixed(2) : ltp}
      thousandsGroupStyle="lakh"
      className={`${classes.root} underlying-pure-value`}
    />
  );
};

export default Price;
